module.exports = __webpack_public_path__ + "img/new-person.268182be.png";